<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    getUsersSelect () {
      this.$store.dispatch('getUsersSelect')
    },

    getStudent_tutors (id) {
      this.$store.dispatch('getStudent_tutors', id)
    },

    // getStudents () {
    //   this.$store.dispatch('getStudentsLimit10')
    // },

    getTutors () {
      this.$store.dispatch('getTutorsLimit10')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    },

    getPrefs () {
      this.$store.dispatch('getPrefs')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getUsersSelect()
      vm.getStudent_tutors(to.params.id)
      // vm.getStudents(to.params.id)
      vm.getTutors(to.params.id)
      vm.getOffices(to.params.id)
      vm.getPrefs(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Student_tutors.vue?308ad8b3